import { FunctionComponent } from 'react'

import { Box } from 'native-base'
import Svg, { G, Path, Defs, ClipPath, Rect } from 'react-native-svg'

type SuccessfulBusinessIllustrationProps = {
  maxH?: number
}

export const SuccessfulBusinessIllustration: FunctionComponent<
  SuccessfulBusinessIllustrationProps
> = ({ maxH = 250 }) => (
  <Box {...{ maxH }}>
    <Svg width={251} height={250} viewBox="0 0 251 250" fill="none">
      <G clipPath="url(#clip0_8667_162419)">
        <Path
          d="M182.27 49.1501L182.01 49.8001L177.76 60.4201L177.55 60.9501C177.41 61.2801 177.16 61.5401 176.85 61.7101C176.53 61.8701 176.17 61.9101 175.83 61.8301C171.82 60.8601 167.79 59.7101 163.85 58.3301C163.84 58.3301 163.83 58.3201 163.82 58.3201C159.23 56.7101 154.75 54.8001 150.54 52.5101C142.68 48.2701 135.72 42.7101 130.62 35.3801C139.15 33.6001 147.91 34.3301 156.45 36.5801H156.46C160.98 37.7701 165.44 39.3901 169.76 41.2901C173.86 43.0901 177.84 45.1401 181.63 47.3101C181.94 47.4901 182.17 47.7701 182.29 48.1101C182.41 48.4501 182.4 48.8201 182.27 49.1501Z"
          fill="#F5F5F5"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M157.22 41.0595C158.06 41.3995 158.78 41.9695 159.3 42.7195C159.81 43.4695 160.09 44.3495 160.1 45.2495C160.11 46.1595 159.85 47.0395 159.36 47.7995C158.87 48.5595 158.16 49.1595 157.33 49.5095C156.5 49.8695 155.58 49.9695 154.69 49.8095C153.8 49.6395 152.98 49.2195 152.33 48.5895C151.68 47.9595 151.23 47.1495 151.05 46.2595C150.86 45.3695 150.94 44.4495 151.28 43.6095C151.5 43.0495 151.83 42.5395 152.25 42.1095C152.67 41.6795 153.17 41.3295 153.72 41.0995C154.27 40.8595 154.87 40.7395 155.47 40.7295C156.07 40.7295 156.67 40.8295 157.23 41.0595H157.22Z"
          fill="#F3123C"
        />
        <Path
          d="M143.72 34.4902L139.74 45.2502"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M157.22 41.0595C158.06 41.3995 158.78 41.9695 159.3 42.7195C159.81 43.4695 160.09 44.3495 160.1 45.2495C160.11 46.1595 159.85 47.0395 159.36 47.7995C158.87 48.5595 158.16 49.1595 157.33 49.5095C156.5 49.8695 155.58 49.9695 154.69 49.8095C153.8 49.6395 152.98 49.2195 152.33 48.5895C151.68 47.9595 151.23 47.1495 151.05 46.2595C150.86 45.3695 150.94 44.4495 151.28 43.6095C151.5 43.0495 151.83 42.5395 152.25 42.1095C152.67 41.6795 153.17 41.3295 153.72 41.0995C154.27 40.8595 154.87 40.7395 155.47 40.7295C156.07 40.7295 156.67 40.8295 157.23 41.0595H157.22Z"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M185.12 52.0898C185.12 52.2898 185.08 52.4998 184.99 52.6898L181.92 60.4098C181.85 60.5998 181.74 60.7798 181.59 60.9198C181.45 61.0698 181.27 61.1898 181.08 61.2698C180.89 61.3498 180.69 61.3898 180.48 61.3898C180.27 61.3898 180.07 61.3498 179.88 61.2698L177.76 60.4198L182.01 49.7998L184.13 50.6498C184.33 50.7198 184.5 50.8298 184.65 50.9798C184.8 51.1198 184.92 51.2898 185 51.4798C185.08 51.6698 185.12 51.8798 185.12 52.0898Z"
          fill="#F5F5F5"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M184.18 34.4298C178.78 35.6198 173.9 37.2898 169.76 41.2898C165.44 39.3898 160.98 37.7698 156.46 36.5798C164.81 32.1998 174.14 31.8698 184.18 34.4298Z"
          fill="#F5F5F5"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M156.46 36.5801H156.45"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M169.96 72.9998C160.74 68.1398 153.79 61.4398 150.54 52.5098C154.75 54.7998 159.23 56.7098 163.82 58.3198C163.83 58.3198 163.84 58.3298 163.85 58.3298C164.25 64.0298 166.75 68.5198 169.96 72.9998Z"
          fill="#F5F5F5"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M213.71 61.3896L229.3 66.1297"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M185.12 52.6895L209.21 60.0195"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M207.76 71.6396L216.17 75.3297"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M202.62 69.4102L203.73 69.8802"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M182.05 60.4102L188.51 63.2402"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M228.26 72.5996L237.35 75.8896"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M183.59 56.5L224.59 71.3"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M35.73 163.21V179.93C35.73 180.95 35.93 181.95 36.32 182.89C36.71 183.83 37.28 184.68 38 185.4C38.72 186.12 39.57 186.69 40.51 187.08C41.45 187.47 42.46 187.67 43.47 187.67H195.05C196.07 187.67 197.07 187.47 198.01 187.08C198.95 186.69 199.8 186.12 200.52 185.4C201.24 184.68 201.81 183.83 202.2 182.89C202.59 181.95 202.79 180.94 202.79 179.93V70.9802C202.79 69.9602 202.59 68.9602 202.2 68.0202C201.81 67.0802 201.24 66.2302 200.52 65.5102C199.8 64.7902 198.95 64.2202 198.01 63.8302C197.07 63.4402 196.06 63.2402 195.05 63.2402H43.47C42.45 63.2402 41.45 63.4402 40.51 63.8302C39.57 64.2202 38.72 64.7902 38 65.5102C37.28 66.2302 36.71 67.0802 36.32 68.0202C35.93 68.9602 35.73 69.9702 35.73 70.9802V163.22V163.21Z"
          fill="#F5F5F5"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M133.45 86.9102H202.8"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M35.73 86.9102H113.28"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M49.72 75.8705C49.72 76.4305 49.55 76.9805 49.24 77.4505C48.93 77.9205 48.48 78.2805 47.96 78.5005C47.44 78.7205 46.87 78.7705 46.32 78.6605C45.77 78.5505 45.26 78.2805 44.86 77.8805C44.46 77.4805 44.19 76.9705 44.08 76.4205C43.97 75.8705 44.03 75.3005 44.24 74.7805C44.46 74.2605 44.82 73.8205 45.29 73.5005C45.76 73.1905 46.31 73.0205 46.87 73.0205C47.62 73.0205 48.35 73.3205 48.88 73.8605C49.41 74.3905 49.71 75.1205 49.72 75.8705Z"
          fill="#F3123C"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M58.3699 75.8705C58.3699 76.4305 58.1999 76.9805 57.8899 77.4505C57.5799 77.9205 57.1299 78.2805 56.6099 78.5005C56.0899 78.7205 55.5199 78.7705 54.9699 78.6605C54.4199 78.5505 53.9099 78.2805 53.5099 77.8805C53.1099 77.4805 52.8399 76.9705 52.7299 76.4205C52.6199 75.8705 52.6799 75.3005 52.8899 74.7805C53.1099 74.2605 53.4699 73.8205 53.9399 73.5005C54.4099 73.1905 54.9599 73.0205 55.5199 73.0205C56.2699 73.0205 56.9999 73.3205 57.5299 73.8605C58.0599 74.3905 58.3599 75.1205 58.3699 75.8705V75.8705Z"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M67.0198 75.8705C67.0198 76.4305 66.8498 76.9805 66.5398 77.4505C66.2298 77.9205 65.7798 78.2805 65.2598 78.5005C64.7398 78.7205 64.1698 78.7705 63.6198 78.6605C63.0698 78.5505 62.5598 78.2805 62.1598 77.8805C61.7598 77.4805 61.4898 76.9705 61.3798 76.4205C61.2698 75.8705 61.3298 75.3005 61.5398 74.7805C61.7598 74.2605 62.1198 73.8205 62.5898 73.5005C63.0598 73.1905 63.6098 73.0205 64.1698 73.0205C64.9198 73.0205 65.6498 73.3205 66.1798 73.8605C66.7098 74.3905 67.0098 75.1205 67.0198 75.8705V75.8705Z"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M228.83 161.15C206.8 145.76 194.49 127.15 187.97 125.58C187.21 125.41 186.47 125.16 185.76 124.84C184.75 124.5 184.72 122.46 184.72 122.23C184.72 121.12 174.22 121.03 174.2 121.98C174.2 121.98 174.15 123.77 172.68 123.63C167.27 122.47 155.45 116.99 153.43 114.21C148.62 107.96 144.22 101.41 140.25 94.5904C138.55 91.5704 136.91 91.5704 136.91 91.5704C134.23 89.8204 125.82 95.1104 126.81 98.5304C126.81 98.5304 126.47 99.8604 128.36 102.73C133.01 109.74 135.96 114.38 142.1 123.77C143.85 126.43 147.61 130.41 163.29 137.1C162.48 139.63 162.33 142.92 163.39 148.6C163.73 150.52 164.3 152.87 164.86 155.36C164.86 158.65 187.26 158.65 187.26 155.36C187.57 152.72 188.29 150.15 189.4 147.74L215.88 174.46C216.49 174.98 217.2 175.36 217.96 175.58C218.73 175.8 219.53 175.85 220.32 175.74L221.67 175.54C219.97 172.49 226.39 164.31 230.55 165.39C230.55 165.39 230.52 162.29 228.83 161.13V161.15Z"
          fill="#F3123C"
        />
        <Path
          d="M176.83 119.581L178.33 118.051L176.86 118.491C176.89 118.851 176.88 119.211 176.83 119.571V119.581Z"
          fill="#404040"
        />
        <Path
          d="M189.47 105.541C190.53 105.541 191.57 105.191 192.4 104.541C193.24 103.891 193.84 102.971 194.1 101.941C194.36 100.911 194.27 99.8208 193.84 98.8508C193.41 97.8808 192.67 97.0708 191.74 96.5708C190.81 96.0608 189.73 95.8908 188.68 96.0608C187.63 96.2408 186.67 96.7608 185.95 97.5408C185.23 98.3208 184.8 99.3208 184.71 100.381C184.63 101.441 184.89 102.501 185.48 103.381C184.76 102.881 183.94 102.551 183.08 102.391C182.22 102.241 181.34 102.271 180.49 102.481C178.38 103.101 176.59 104.481 175.45 106.361C178.45 102.111 181.13 106.971 181.2 110.021C181.27 110.661 181.64 110.781 182.58 109.951C184.55 108.231 186.46 111.781 182.63 113.811C182.18 114.671 181.92 115.621 181.89 116.591C181.79 117.451 181.77 118.331 181.82 119.191C182.16 117.201 186.2 114.101 187.72 110.261C188.02 109.331 188.09 108.341 187.94 107.371C187.78 106.411 187.4 105.491 186.82 104.701C187.6 105.231 188.52 105.511 189.47 105.521V105.541Z"
          fill="#404040"
        />
        <Path
          d="M178.87 136.64L185.24 137.55L185.71 134.16L179.37 133.25L178.88 136.64H178.87Z"
          fill="#404040"
        />
        <Path
          d="M190.77 145.2C190.23 146.18 189.78 146.97 189.42 147.76L196.3 154.72L190.77 145.2Z"
          fill="#404040"
        />
        <Path
          d="M133.72 90.5004C131.58 86.2204 130.66 81.4404 131.05 76.6804C131.42 72.1104 131.53 71.2704 131.85 68.7504C131.87 68.5504 131.63 68.2304 131.43 68.3304C129.9 69.0304 126.74 78.2504 126.47 83.3304"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M126.69 95.2908C125.56 94.4808 124.7 93.3308 124.23 92.0208C123.02 87.9508 123 83.6208 124.16 79.5308C124.71 77.7608 125.62 78.0508 126.08 80.9108C126.48 83.4408 127.14 86.9108 127.14 86.9108"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M133.79 90.4504C132.17 86.9204 131.6 83.0104 132.12 79.1704C132.64 76.8904 133.35 74.6704 134.23 72.5104C134.37 72.0704 133.81 71.4304 132.16 73.8604L131.15 75.4304"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M134.52 90.5308C133.33 87.7308 132.9 84.6508 133.3 81.6308C133.69 79.6508 134.24 77.7108 134.95 75.8308C135.1 75.4108 134.58 74.7808 132.96 76.9908C132.83 77.1608 132.71 77.3108 132.44 77.6808"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M184.77 122.33C188.67 121.34 192.08 119 194.4 115.71C196.72 112.42 197.78 108.42 197.41 104.42C197.03 100.42 195.24 96.6803 192.35 93.8903C189.46 91.1003 185.67 89.4303 181.66 89.1903C177.65 88.9503 173.68 90.1503 170.48 92.5803C167.28 95.0103 165.05 98.5003 164.19 102.43C163.34 106.36 163.91 110.46 165.82 114C167.73 117.54 170.83 120.28 174.58 121.73"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M176.69 121.33C176.81 120.37 176.87 119.41 176.85 118.45"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M175.43 106.351C174.67 107.521 174.06 108.791 173.61 110.111C170.2 119.321 175.63 118.761 177.64 118.271L178.33 118.051L176.83 119.581"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M182.32 121.5C182.02 120.77 181.86 120 181.83 119.21"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M230.5 165.38C230.5 165.38 230.5 162.31 228.83 161.15C206.77 145.82 194.5 127.11 187.97 125.58C187.21 125.41 186.47 125.16 185.76 124.84C184.75 124.5 184.72 122.45 184.72 122.23C184.72 121.12 174.22 121.02 174.2 121.98C174.2 121.98 174.15 123.78 172.68 123.63C167.27 122.48 155.45 116.99 153.43 114.21C148.63 107.96 144.23 101.4 140.25 94.5904C138.55 91.5704 136.91 91.5704 136.91 91.5704C134.23 89.8204 125.82 95.1104 126.81 98.5304C126.81 98.5304 126.46 99.8604 128.36 102.73C132.99 109.75 135.95 114.39 142.1 123.77C143.84 126.43 147.61 130.41 163.29 137.1C162.48 139.63 162.35 142.92 163.39 148.6C163.74 150.52 164.3 152.87 164.86 155.36C164.86 158.65 187.26 158.65 187.26 155.36C187.57 152.72 188.29 150.15 189.4 147.74L215.88 174.44C216.49 174.96 217.2 175.34 217.96 175.56C218.73 175.78 219.53 175.83 220.32 175.72L221.67 175.55"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M126.78 98.4303C124.48 93.4703 133.25 88.1703 136.94 91.5803"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M165.31 133.15C164.45 134.37 163.78 135.7 163.29 137.11"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M235.38 183.35C235.09 182.83 234.83 182.3 234.58 181.75L235.38 183.35Z"
          fill="#F5F5F5"
        />
        <Path
          d="M235.38 183.35C235.09 182.83 234.83 182.3 234.58 181.75"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M238.49 181.461C238 180.871 237.56 180.241 237.15 179.591L238.49 181.461Z"
          fill="#F5F5F5"
        />
        <Path
          d="M238.49 181.461C238 180.871 237.56 180.241 237.15 179.591"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M235.38 183.35C235.38 183.35 235.31 183.3 235.29 183.29L235.38 183.35Z"
          fill="#F5F5F5"
        />
        <Path
          d="M235.38 183.35C235.38 183.35 235.31 183.3 235.29 183.29"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M245.37 184.08C242.69 183.17 239.41 181.84 238.49 181.46C239.42 182.62 240.49 183.67 241.68 184.58C245.08 187.46 243.78 188.36 240.5 186.42C237.95 184.91 235.87 183.66 235.38 183.35C236.13 184.7 237.03 185.96 238.07 187.11C240.88 190.25 239.78 190.92 236.82 188.73C236.03 188.15 235.35 187.6 234.78 187.14C233.13 185.76 231.51 184.41 229.84 183.1C227.65 181.33 225.4 179.19 223.41 177.2C222.27 174.78 230.27 166.2 232.65 167.29C232.66 167.28 232.67 167.3 232.67 167.3C232.93 167.53 233.66 168.15 233.92 168.37C234.54 168.9 235.51 168.51 236.08 168.12C238.06 166.78 240.79 164.54 241.39 165.52C242.31 167.03 238.07 169.98 237.55 171.99C237.41 172.53 238.41 173.25 239 173.64C239.76 174.13 245.2 176.48 245.4 176.56C249.09 178.03 248.22 179.48 244.9 178.65C243.35 178.22 241.57 178.05 239.94 178.01C241.97 179.3 245.75 181.69 246.08 181.89C249.49 183.89 248.81 185.25 245.37 184.08Z"
          fill="#F5F5F5"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M238.49 181.46C238.33 181.4 238.24 181.36 238.24 181.36L238.49 181.46Z"
          fill="#F5F5F5"
        />
        <Path
          d="M238.49 181.46C238.33 181.4 238.24 181.36 238.24 181.36"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M239.94 178.01C239.18 177.53 238.66 177.2 238.66 177.2L239.94 178.01Z"
          fill="#F5F5F5"
        />
        <Path
          d="M239.94 178.01C239.18 177.53 238.66 177.2 238.66 177.2"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path d="M232.65 167.291L232.57 167.221L232.65 167.291Z" fill="#F5F5F5" />
        <Path
          d="M232.65 167.291L232.57 167.221"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path d="M239.94 178.011H239.7H239.94Z" fill="#F5F5F5" />
        <Path
          d="M239.94 178.011H239.7"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M239.47 175.561C238.34 178.411 236.3 180.811 233.67 182.391"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M236.91 175.23C234.13 177.39 231.38 177.96 228.87 176.07"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M232.91 167.46C232.84 167.39 232.76 167.33 232.67 167.3C232.67 167.3 232.66 167.28 232.65 167.29C230.27 166.2 222.27 174.78 223.41 177.2C223.45 177.3 223.51 177.39 223.59 177.47C222.73 177.11 222.04 176.42 221.67 175.55C219.98 172.5 226.39 164.32 230.55 165.4C231.08 165.52 231.58 165.77 231.99 166.13C232.4 166.49 232.72 166.95 232.91 167.46Z"
          fill="#F5F5F5"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M221.67 172.801L223.78 174.911"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M222.88 170.29L225.29 172.58"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M224.79 167.96L227.27 170.32"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M227.28 166.04L229.47 168.42"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M229.67 165.311L231.63 167.231"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M181.18 109.85C181 106.79 178.37 102.22 175.44 106.38C176.58 104.5 178.38 103.11 180.49 102.5C181.52 102.25 182.59 102.26 183.61 102.55C184.63 102.84 185.56 103.39 186.3 104.14C187.04 104.9 187.58 105.83 187.85 106.85C188.12 107.87 188.12 108.95 187.85 109.97C186.84 113.39 182.18 117.21 181.84 119.21C181.79 118.34 181.82 117.47 181.91 116.61C181.95 115.64 182.2 114.69 182.65 113.83C186.48 111.8 184.56 108.24 182.6 109.97C181.81 110.65 181.24 110.89 181.18 109.85V109.85Z"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M194.24 100.77C194.24 101.71 193.96 102.63 193.44 103.42C192.91 104.2 192.17 104.82 191.3 105.18C190.43 105.54 189.47 105.64 188.54 105.45C187.61 105.27 186.77 104.81 186.1 104.14C185.43 103.47 184.98 102.62 184.79 101.7C184.61 100.77 184.7 99.82 185.06 98.94C185.42 98.07 186.03 97.32 186.82 96.8C187.6 96.28 188.53 96 189.47 96C190.73 96 191.95 96.5 192.84 97.4C193.73 98.29 194.24 99.51 194.24 100.77V100.77Z"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M164.86 160.261C164.86 163.161 187.18 163.161 187.18 160.261"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M197.95 187.111C196.3 165.971 187.18 160.271 187.18 160.271L187.25 155.381"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M158.79 187.67L164.86 160.26V155.37"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M173.12 187.67L173.76 178.4L172.38 177.29"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M177.03 121.37C177.03 129.78 169.75 131.5 171.99 157.68"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M185.24 137.55L178.87 136.64L179.36 133.25L185.7 134.16L185.23 137.55H185.24Z"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M196.3 154.71L190.76 145.17C190.21 146.16 189.77 146.96 189.4 147.75"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M45.5898 150.769C46.5498 149.749 47.5898 148.809 48.6898 147.939L50.2898 157.599C48.5798 155.419 47.0098 153.139 45.5898 150.769Z"
          fill="#F3123C"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M117.42 101.41C118.94 99.3896 118.55 98.1696 118.55 98.1696C118.75 94.9496 112.31 89.6396 109.38 90.1996C108.77 90.0396 108.13 90.0596 107.53 90.2696C106.93 90.4796 106.41 90.8496 106.03 91.3596C95.8101 104.29 79.0901 122.21 70.0201 127.62C69.9001 127.64 69.7801 127.62 69.6701 127.57C69.5601 127.52 69.4801 127.43 69.4201 127.32C69.0601 126.44 68.8701 125.5 68.8801 124.54L66.6001 124.49L61.1901 124.38L58.3401 124.32C58.3401 124.32 58.0701 127.15 57.0401 127.66C49.2201 129.77 39.9801 136.93 33.8801 142.28C31.8201 144.07 30.4601 146.54 30.0501 149.24C29.6401 151.94 30.1901 154.7 31.6201 157.03C35.8201 163.91 41.8401 171.63 47.4301 176.2C47.9201 176.59 48.4401 176.96 48.9501 177.31C46.1701 173.57 55.6901 164.55 58.8301 166.49C57.0401 165.07 55.3601 163.51 53.8301 161.82C55.7401 163.1 74.1401 163.31 74.5401 161.38C77.2601 155.69 78.4901 149.41 78.1301 143.12C92.7101 132.77 108.02 113.58 117.41 101.41H117.42ZM48.6901 147.95C47.5901 148.81 46.5501 149.76 45.5901 150.78C47.0101 153.16 48.5801 155.44 50.2901 157.61L48.6901 147.95Z"
          fill="#F3123C"
        />
        <Path
          d="M66.4602 124.3C66.4602 123.94 66.5102 123.57 66.5802 123.22L65.1802 122.58L66.4602 124.3Z"
          fill="#404040"
        />
        <Path
          d="M70.0701 111.979C70.6101 111.819 71.0801 111.469 71.4001 110.999C71.7201 110.529 71.8601 109.959 71.8001 109.399C71.7401 108.839 71.4901 108.309 71.0901 107.909C70.6901 107.509 70.1601 107.259 69.6001 107.209C69.9701 106.809 70.1901 106.299 70.2301 105.749C70.2701 105.209 70.1301 104.669 69.8301 104.209C69.5301 103.759 69.0901 103.419 68.5701 103.239C68.0501 103.069 67.5001 103.069 66.9801 103.239C67.1001 102.699 67.0401 102.139 66.8001 101.639C66.5601 101.139 66.1601 100.739 65.6701 100.499C65.1801 100.259 64.6101 100.189 64.0801 100.309C63.5401 100.429 63.0601 100.719 62.7101 101.149C62.6001 100.599 62.3101 100.099 61.8801 99.7395C61.4501 99.3795 60.9101 99.1795 60.3501 99.1795C59.9001 99.1595 59.4401 99.2595 59.0401 99.4695C58.6401 99.6795 58.2901 99.9895 58.0501 100.379C57.9001 100.039 57.6601 99.7495 57.3601 99.5295C57.0601 99.3095 56.7101 99.1695 56.3401 99.1295C56.6701 98.7195 56.8301 98.1995 56.8001 97.6795C56.7701 97.1595 56.5501 96.6595 56.1801 96.2895C55.8101 95.9195 55.3201 95.6895 54.7901 95.6595C54.2701 95.6295 53.7501 95.7895 53.3301 96.1095C53.2501 95.5795 52.9801 95.0995 52.5701 94.7595C52.1601 94.4095 51.6501 94.2295 51.1201 94.2295C50.5901 94.2295 50.0701 94.4295 49.6701 94.7795C49.2701 95.1295 49.0101 95.6095 48.9301 96.1395C48.5601 95.8595 48.1101 95.7095 47.6501 95.6995C47.2401 95.6995 46.8401 95.8095 46.4901 96.0295C46.1401 96.2495 45.8701 96.5595 45.6901 96.9295C45.5101 97.2995 45.4501 97.7095 45.5001 98.1195C45.5501 98.5295 45.7101 98.9095 45.9701 99.2195C45.4501 99.2895 44.9701 99.5395 44.6301 99.9295C44.2901 100.319 44.1001 100.829 44.1001 101.349C44.1001 101.869 44.3001 102.379 44.6501 102.769C45.0001 103.159 45.4801 103.409 46.0001 103.469C45.7101 103.829 45.5601 104.279 45.5601 104.749C45.5601 105.159 45.6701 105.559 45.8801 105.899C46.0901 106.249 46.4001 106.519 46.7701 106.699C47.1401 106.879 47.5501 106.949 47.9501 106.899C48.3501 106.849 48.7401 106.689 49.0501 106.439C49.1101 106.929 49.3401 107.389 49.7001 107.729C49.3301 107.999 49.0501 108.369 48.8801 108.799C48.7101 109.219 48.6701 109.689 48.7501 110.139C48.8301 110.589 49.0301 111.009 49.3401 111.349C49.6401 111.689 50.0401 111.939 50.4801 112.069C50.1401 112.299 49.8701 112.609 49.6701 112.969C49.4801 113.329 49.3701 113.729 49.3701 114.139C49.3701 114.489 49.4301 114.829 49.5701 115.149C49.7101 115.469 49.9101 115.749 50.1701 115.989C50.4301 116.219 50.7301 116.399 51.0701 116.499C51.4001 116.599 51.7501 116.639 52.1001 116.599C51.8601 117.079 51.7901 117.629 51.9001 118.159C52.0101 118.689 52.2901 119.169 52.6901 119.519C53.1001 119.869 53.6101 120.079 54.1501 120.109C54.6901 120.139 55.2201 119.999 55.6701 119.689C55.6701 120.249 55.8701 120.789 56.2301 121.229C56.5901 121.659 57.0801 121.959 57.6401 122.069C58.1901 122.179 58.7601 122.099 59.2601 121.829C59.7601 121.569 60.1501 121.139 60.3701 120.619C60.6401 121.229 61.1301 121.699 61.7501 121.949L61.8501 120.649C61.9701 119.679 61.8501 118.689 61.5101 117.769C58.0701 115.139 60.4001 111.969 62.0801 113.959C62.8901 114.889 63.2801 114.849 63.4301 114.229C64.0001 110.709 68.4801 105.229 70.7301 114.549L70.9301 115.359C71.1001 115.079 71.2101 114.769 71.2601 114.449C71.3101 114.129 71.2901 113.799 71.2101 113.479C71.1301 113.159 70.9901 112.869 70.7901 112.609C70.5901 112.349 70.3501 112.129 70.0601 111.969L70.0701 111.979Z"
          fill="#404040"
        />
        <Path
          d="M71.52 135.259L71.89 138.459L75.43 138.069L75.06 134.869L71.52 135.259Z"
          fill="#404040"
        />
        <Path
          d="M49.2302 151.439L56.3302 142.739C53.6802 144.349 51.1202 146.089 48.6602 147.979L49.2302 151.449V151.439Z"
          fill="#404040"
        />
        <Path
          d="M60.9803 167.22C60.3403 167.17 59.7803 167.12 59.2803 167.05"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M74.6502 165.72C74.6502 166.63 68.5302 167.27 63.6602 167.27"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M66.46 124.469C66.46 124.009 66.51 123.559 66.6 123.119"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M120 83.2496C120.37 77.9596 116.92 67.7896 115.38 66.8796C115.34 66.8596 115.29 66.8496 115.25 66.8496C115.2 66.8496 115.16 66.8696 115.12 66.8896C115.08 66.9096 115.05 66.9496 115.03 66.9896C115.01 67.0296 115 67.0796 115 67.1196C115.63 72.8596 116.97 84.6196 112.79 89.7596"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M119.09 95.7092C120.84 94.3092 122.73 92.0992 122.78 90.3792C122.95 84.5292 123.16 81.7992 123.3 79.5092C123.4 77.8092 122.07 77.6692 120.96 80.5492C119.98 83.0792 118.89 86.6692 118.89 86.6692"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M115.48 73.61C115.04 72.73 114.69 72.13 114.5 71.77C113.05 69.06 112.38 69.66 112.48 70.15C112.87 72.07 113.88 75.26 114.18 77.06C114.75 81.34 114.04 85.7 112.14 89.58"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M61.17 124.35C62.19 122.2 61.94 118.06 61.54 117.76C58.09 115.15 60.43 111.96 62.11 113.95C62.73 114.68 63.31 115.07 63.48 114.12C64.11 110.6 68.53 105.32 70.76 114.54C70.78 114.69 72.16 119.39 70.91 121.87C69.78 124.1 67.1 123.36 65.84 122.85L65.18 122.58L66.46 124.28L65.18 122.58"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M71.99 175.949C72.58 176.069 72.68 176.089 72.95 176.149C76.5 176.839 76.05 177.819 75.46 177.869C73.17 178.079 69.78 178.009 67.64 178.069C66.35 178.099 63.79 178.019 61.73 178.229"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M57.0898 179.189C58.8798 179.089 66.3798 176.929 68.7198 176.439C70.7898 175.999 74.4198 175.689 76.6598 175.279C77.2298 175.179 77.5898 174.239 74.0298 173.809C72.1698 173.629 70.3098 173.619 68.4498 173.789"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M60.6299 173.959C58.0299 173.759 61.8799 170.149 63.1899 168.139C64.2699 166.469 64.7899 164.379 60.3599 167.669C59.7099 168.189 58.9699 168.569 58.1699 168.799"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M48.96 177.3C46.11 173.49 56.11 164.15 59.04 166.63C59.04 166.63 51.42 161.25 44.27 148.52"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M77.7403 138.04C79.1203 149.74 77.0003 155.74 74.5503 161.37C74.4403 162.82 74.4803 164.28 74.6503 165.72C76.1803 172.43 82.9303 187.55 82.9303 187.55"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M118.55 98.1392C118.75 94.9192 112.3 89.6092 109.38 90.1692C112.38 86.9192 121.9 95.5292 118.55 98.1392Z"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M78.1401 143.109C92.7201 132.759 108.02 113.549 117.42 101.389C118.94 99.4194 118.55 98.1494 118.55 98.1494"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M109.38 90.1794C108.77 90.0294 108.13 90.0594 107.54 90.2594C106.95 90.4694 106.43 90.8394 106.04 91.3294C95.8101 104.269 79.1001 122.209 70.0301 127.589C69.9301 127.619 69.8301 127.609 69.7401 127.569C68.9601 127.209 68.9001 124.519 68.9001 124.519L58.3501 124.299C58.3501 124.299 58.0601 127.349 56.9301 127.689C56.8001 127.759 48.8601 129.109 33.9001 142.269C31.8401 144.059 30.4801 146.529 30.0701 149.229C29.6601 151.929 30.2101 154.689 31.6401 157.019C35.8501 163.899 41.8601 171.629 47.4501 176.189C49.2801 177.709 51.4701 178.729 53.8201 179.139C58.5901 179.919 60.8301 177.579 62.9601 176.239C65.0501 175.059 67.2701 174.119 69.5701 173.439C72.9601 172.439 73.1801 171.889 69.3501 171.549C66.2601 171.369 63.1601 171.599 60.1301 172.239"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M51.2403 178.459C50.0103 177.889 50.8703 171.379 58.1703 168.819C59.7203 168.279 59.4203 166.899 59.0303 166.659"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M48.5898 174.6L50.9298 175.98"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M49.8701 171.96L52.1101 173.31"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M51.8101 169.63L53.8301 171.33"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M54.1401 167.689L55.7101 169.929"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M56.8999 166.34L57.8099 168.95"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M74.5399 161.369C74.5399 163.289 53.3999 163.289 53.3999 161.369"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M50.2602 157.61L48.6602 147.97"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M43.5502 172.6C41.7802 177.33 41.1302 182.42 41.6602 187.44"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M66.8001 187.67L66.3301 182.51L68.0801 181.04"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M65.8701 124.46C66.1001 129.42 72.9701 135.75 69.1601 162.63"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M71.7001 171.92C74.2901 169.12 75.8501 165.52 76.1301 161.71C76.4101 157.9 75.3801 154.12 73.2301 150.97C71.0701 147.82 67.9101 145.5 64.2601 144.38C60.6101 143.26 56.6901 143.42 53.1401 144.82"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M35.73 177.299V167.659"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M56.3301 187.67H46.6401"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M75.43 138.069L71.89 138.459L71.52 135.259L75.06 134.869L75.43 138.069Z"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M45.5898 150.77C48.6198 147.52 53.1598 144.73 56.3098 142.76L49.2598 151.43"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M70.0701 111.979C70.6101 111.819 71.0801 111.469 71.4001 110.999C71.7201 110.529 71.8601 109.959 71.8001 109.399C71.7401 108.839 71.4901 108.309 71.0901 107.909C70.6901 107.509 70.1601 107.259 69.6001 107.209C69.9701 106.809 70.1901 106.299 70.2301 105.749C70.2701 105.209 70.1301 104.669 69.8301 104.209C69.5301 103.759 69.0901 103.419 68.5701 103.239C68.0501 103.069 67.5001 103.069 66.9801 103.239C67.1001 102.699 67.0401 102.139 66.8001 101.639C66.5601 101.139 66.1601 100.739 65.6701 100.499C65.1801 100.259 64.6101 100.189 64.0801 100.309C63.5401 100.429 63.0601 100.719 62.7101 101.149C62.6001 100.599 62.3101 100.099 61.8801 99.7395C61.4501 99.3795 60.9101 99.1795 60.3501 99.1795C59.9001 99.1595 59.4401 99.2595 59.0401 99.4695C58.6401 99.6795 58.2901 99.9895 58.0501 100.379C57.9001 100.039 57.6601 99.7495 57.3601 99.5295C57.0601 99.3095 56.7101 99.1695 56.3401 99.1295C56.6701 98.7195 56.8301 98.1995 56.8001 97.6795C56.7701 97.1595 56.5501 96.6595 56.1801 96.2895C55.8101 95.9195 55.3201 95.6895 54.7901 95.6595C54.2701 95.6295 53.7501 95.7895 53.3301 96.1095C53.2501 95.5795 52.9801 95.0995 52.5701 94.7595C52.1601 94.4095 51.6501 94.2295 51.1201 94.2295C50.5901 94.2295 50.0701 94.4295 49.6701 94.7795C49.2701 95.1295 49.0101 95.6095 48.9301 96.1395C48.5601 95.8595 48.1101 95.7095 47.6501 95.6995C47.2401 95.6995 46.8401 95.8095 46.4901 96.0295C46.1401 96.2495 45.8701 96.5595 45.6901 96.9295C45.5101 97.2995 45.4501 97.7095 45.5001 98.1195C45.5501 98.5295 45.7101 98.9095 45.9701 99.2195C45.4501 99.2895 44.9701 99.5395 44.6301 99.9295C44.2901 100.319 44.1001 100.829 44.1001 101.349C44.1001 101.869 44.3001 102.379 44.6501 102.769C45.0001 103.159 45.4801 103.409 46.0001 103.469C45.7101 103.829 45.5601 104.279 45.5601 104.749C45.5601 105.159 45.6701 105.559 45.8801 105.899C46.0901 106.249 46.4001 106.519 46.7701 106.699C47.1401 106.879 47.5501 106.949 47.9501 106.899C48.3501 106.849 48.7401 106.689 49.0501 106.439C49.1101 106.929 49.3401 107.389 49.7001 107.729C49.3301 107.999 49.0501 108.369 48.8801 108.799C48.7101 109.219 48.6701 109.689 48.7501 110.139C48.8301 110.589 49.0301 111.009 49.3401 111.349C49.6401 111.689 50.0401 111.939 50.4801 112.069C50.1401 112.299 49.8701 112.609 49.6701 112.969C49.4801 113.329 49.3701 113.729 49.3701 114.139C49.3701 114.489 49.4301 114.829 49.5701 115.149C49.7101 115.469 49.9101 115.749 50.1701 115.989C50.4301 116.219 50.7301 116.399 51.0701 116.499C51.4001 116.599 51.7501 116.639 52.1001 116.599C51.8601 117.079 51.7901 117.629 51.9001 118.159C52.0101 118.689 52.2901 119.169 52.6901 119.519C53.1001 119.869 53.6101 120.079 54.1501 120.109C54.6901 120.139 55.2201 119.999 55.6701 119.689C55.6701 120.249 55.8701 120.789 56.2301 121.229C56.5901 121.659 57.0801 121.959 57.6401 122.069C58.1901 122.179 58.7601 122.099 59.2601 121.829C59.7601 121.569 60.1501 121.139 60.3701 120.619C60.6401 121.229 61.1301 121.699 61.7501 121.949L61.8501 120.649C61.9701 119.679 61.8501 118.689 61.5101 117.769C58.0701 115.139 60.4001 111.969 62.0801 113.959C62.8901 114.889 63.2801 114.849 63.4301 114.229C64.0001 110.709 68.4801 105.229 70.7301 114.549L70.9301 115.359C71.1001 115.079 71.2101 114.769 71.2601 114.449C71.3101 114.129 71.2901 113.799 71.2101 113.479C71.1301 113.159 70.9901 112.869 70.7901 112.609C70.5901 112.349 70.3501 112.129 70.0601 111.969L70.0701 111.979Z"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinejoin="round"
        />
        <Path
          d="M118.84 174.55L119.26 140.04L96.9897 166.42C103.11 171.59 110.84 174.47 118.84 174.56V174.55Z"
          fill="#F3123C"
        />
        <Path
          d="M118.84 174.55C133.09 175.02 147.19 165.52 152.03 150.83L119.26 140.04L118.84 174.55Z"
          fill="#404040"
        />
        <Path
          d="M139.18 168.229L144.29 174.549L139.18 178.189"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M107.02 172.31L104.63 180.08L98.75 177.87"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M113.85 105.96C119.87 105.01 126.03 105.67 131.72 107.85"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M152.03 150.82L119.26 140.03L133.2 110.11"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M84.82 137.87C84.51 142.82 85.27 147.77 87.04 152.4C88.82 157.03 91.57 161.22 95.11 164.69C98.65 168.16 102.9 170.83 107.56 172.51C112.22 174.19 117.19 174.85 122.13 174.44C127.07 174.03 131.86 172.56 136.18 170.13C140.5 167.7 144.25 164.37 147.16 160.36C150.08 156.35 152.09 151.76 153.08 146.9C154.06 142.04 153.99 137.03 152.86 132.2"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M96.9897 166.38L119.26 140.03L118.84 174.54"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M110.27 122.979H106.45C105.71 122.979 104.98 123.229 104.4 123.689C103.82 124.149 103.41 124.799 103.23 125.519C103.05 126.239 103.14 127.009 103.45 127.679C103.77 128.349 104.3 128.899 104.96 129.239L108.44 130.979C109.11 131.309 109.64 131.859 109.96 132.539C110.27 133.209 110.35 133.969 110.18 134.699C110.01 135.429 109.6 136.069 109.01 136.529C108.43 136.989 107.7 137.239 106.96 137.239H103.13"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M105.82 137.25V139.93"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M107.6 120.3V122.98"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M38.5302 193.75C36.5302 193.75 34.6002 193.04 33.0702 191.75C31.5402 190.46 30.5202 188.67 30.1902 186.7C29.8602 184.73 30.2302 182.7 31.2502 180.98C32.2702 179.26 33.8602 177.96 35.7502 177.3V167.66C35.2402 167.95 34.8202 168.37 34.5202 168.87C34.2302 169.38 34.0702 169.95 34.0802 170.53C34.0802 171.46 33.2202 171.59 32.4802 171.91C32.2802 172.01 32.0602 172.03 31.8402 171.99C31.6202 171.95 31.4302 171.84 31.2702 171.69C30.9602 171.38 30.6002 171.13 30.1902 170.97C29.7902 170.8 29.3502 170.72 28.9202 170.72C28.4902 170.72 28.0502 170.8 27.6502 170.97C27.2502 171.14 26.8802 171.38 26.5702 171.69L24.9702 173.29C24.6602 173.6 24.4102 173.96 24.2502 174.37C24.0902 174.78 24.0002 175.2 24.0002 175.64C24.0002 176.08 24.0902 176.51 24.2502 176.91C24.4202 177.31 24.6602 177.68 24.9702 177.99C25.6302 178.65 25.1002 179.34 24.8202 180.1C24.7402 180.3 24.6002 180.48 24.4202 180.6C24.2402 180.72 24.0302 180.79 23.8102 180.79C22.9302 180.79 22.0902 181.14 21.4602 181.76C20.8402 182.38 20.4902 183.23 20.4902 184.11V186.37C20.4902 187.25 20.8402 188.09 21.4602 188.72C22.0802 189.34 22.9302 189.69 23.8102 189.69C24.6902 189.69 24.8702 190.55 25.1902 191.29C25.2802 191.49 25.3102 191.71 25.2702 191.93C25.2302 192.15 25.1202 192.34 24.9702 192.5C24.3502 193.13 24.0102 193.97 24.0102 194.85C24.0102 195.73 24.3602 196.57 24.9702 197.2L26.5702 198.8C26.8802 199.11 27.2402 199.35 27.6502 199.52C28.0502 199.69 28.4902 199.77 28.9202 199.77C29.3502 199.77 29.7902 199.68 30.1902 199.52C30.5902 199.36 30.9602 199.11 31.2702 198.8C31.9302 198.14 32.6202 198.68 33.3802 198.95C33.5802 199.03 33.7602 199.17 33.8802 199.35C34.0002 199.53 34.0702 199.74 34.0702 199.96C34.0702 200.4 34.1602 200.83 34.3202 201.23C34.4902 201.63 34.7302 202 35.0402 202.31C35.3502 202.62 35.7202 202.86 36.1202 203.03C36.5202 203.2 36.9602 203.28 37.3902 203.28H39.6502C40.5302 203.28 41.3702 202.93 42.0002 202.31C42.6202 201.69 42.9702 200.84 42.9702 199.96C42.9702 199.03 43.8302 198.9 44.5702 198.58C44.7702 198.49 44.9902 198.46 45.2102 198.5C45.4302 198.54 45.6202 198.65 45.7802 198.8C46.0902 199.11 46.4502 199.35 46.8602 199.52C47.2602 199.69 47.7002 199.77 48.1302 199.77C48.5602 199.77 49.0002 199.68 49.4002 199.52C49.8002 199.35 50.1702 199.11 50.4802 198.8L52.0802 197.2C52.3902 196.89 52.6402 196.53 52.8002 196.12C52.9702 195.72 53.0502 195.29 53.0502 194.85C53.0502 194.41 52.9602 193.98 52.8002 193.58C52.6302 193.18 52.3902 192.81 52.0802 192.5C51.4202 191.89 51.9602 191.1 52.2302 190.39C52.3102 190.19 52.4502 190.01 52.6302 189.89C52.8102 189.77 53.0202 189.7 53.2402 189.7C53.9002 189.7 54.5502 189.5 55.0902 189.13C55.6402 188.76 56.0602 188.24 56.3102 187.62H46.6202C46.1302 189.38 45.0702 190.94 43.6102 192.04C42.1502 193.15 40.3702 193.74 38.5402 193.74L38.5302 193.75Z"
          fill="#404040"
        />
        <Path
          d="M35.7302 167.66C35.2202 167.95 34.8002 168.37 34.5002 168.87C34.2102 169.38 34.0502 169.95 34.0502 170.53C34.0502 171.46 33.1902 171.59 32.4502 171.91C32.2502 172.01 32.0302 172.03 31.8102 171.99C31.5902 171.95 31.4002 171.84 31.2402 171.69C30.9302 171.38 30.5702 171.13 30.1602 170.97C29.7602 170.8 29.3202 170.72 28.8902 170.72C28.4602 170.72 28.0202 170.8 27.6202 170.97C27.2202 171.14 26.8502 171.38 26.5402 171.69L24.9202 173.31C24.6102 173.62 24.3602 173.98 24.2002 174.39C24.0302 174.79 23.9502 175.23 23.9502 175.66C23.9502 176.09 24.0402 176.53 24.2002 176.93C24.3702 177.33 24.6102 177.7 24.9202 178.01C25.5802 178.67 25.0502 179.36 24.7702 180.12C24.6902 180.33 24.5602 180.51 24.3802 180.63C24.2002 180.76 23.9902 180.83 23.7702 180.83C22.8902 180.83 22.0502 181.18 21.4202 181.8C20.8002 182.42 20.4502 183.27 20.4502 184.15V186.41C20.4502 187.29 20.8002 188.14 21.4202 188.76C22.0402 189.38 22.8902 189.73 23.7702 189.73C24.6502 189.73 24.8302 190.59 25.1502 191.33C25.2402 191.53 25.2702 191.75 25.2302 191.97C25.1902 192.19 25.0802 192.38 24.9302 192.54C24.3002 193.17 23.9502 194.02 23.9502 194.9C23.9502 195.78 24.3002 196.63 24.9302 197.26L26.5502 198.86C26.8602 199.17 27.2202 199.42 27.6302 199.58C28.0302 199.75 28.4702 199.84 28.9002 199.84C29.3302 199.84 29.7702 199.75 30.1702 199.58C30.5702 199.41 30.9402 199.17 31.2502 198.86C31.9102 198.2 32.6002 198.73 33.3602 199.01C33.5902 199.1 33.7802 199.27 33.9002 199.48C34.0202 199.69 34.0802 199.94 34.0502 200.18C34.0902 201.04 34.4502 201.84 35.0702 202.44C35.6902 203.03 36.5102 203.36 37.3702 203.36H39.6602C40.5402 203.36 41.3802 203.01 42.0102 202.39C42.6302 201.77 42.9802 200.92 42.9802 200.04C42.9802 199.1 43.8402 198.98 44.5802 198.66C44.7802 198.57 45.0002 198.54 45.2202 198.58C45.4402 198.62 45.6302 198.73 45.7902 198.89C46.1002 199.2 46.4602 199.44 46.8702 199.61C47.2702 199.78 47.7102 199.87 48.1402 199.87C48.5702 199.87 49.0102 199.78 49.4102 199.61C49.8102 199.44 50.1802 199.2 50.4902 198.89L52.1102 197.27C52.4202 196.96 52.6702 196.6 52.8302 196.19C53.0002 195.79 53.0802 195.36 53.0802 194.92C53.0802 194.48 52.9902 194.05 52.8302 193.65C52.6602 193.25 52.4202 192.88 52.1102 192.57C51.4502 191.91 51.9902 191.22 52.2602 190.46C52.3402 190.25 52.4802 190.08 52.6602 189.96C52.8402 189.84 53.0502 189.77 53.2702 189.77C53.9302 189.77 54.5802 189.57 55.1202 189.2C55.6702 188.83 56.0902 188.31 56.3402 187.7"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M155.52 198.319V212.109"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M162.4 205.229H148.61"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M226.91 143.84L227.06 138.14L221.41 138.04L221.53 132.34L215.75 132.12L215.87 126.42L210.02 126.27"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M241.44 151.46L241.59 145.73L235.91 145.66L236.06 139.93L230.26 139.73L230.41 134L224.53 133.85"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M96.1304 21.4697V23.7597"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M93.9702 25.9199H91.6802"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M100.6 25.9199H98.29"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M96.1304 30.3901V28.0801"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M98.2902 25.9198C97.7202 25.9198 97.1702 25.6898 96.7602 25.2898C96.3502 24.8798 96.1302 24.3298 96.1302 23.7598C96.1302 24.0398 96.0802 24.3298 95.9702 24.5898C95.8602 24.8498 95.7002 25.0898 95.5002 25.2898C95.3002 25.4898 95.0602 25.6498 94.8002 25.7598C94.5402 25.8698 94.2502 25.9198 93.9702 25.9198C94.5402 25.9198 95.0902 26.1498 95.5002 26.5498C95.9102 26.9598 96.1302 27.5098 96.1302 28.0798C96.1302 27.7998 96.1802 27.5098 96.2902 27.2498C96.4002 26.9898 96.5602 26.7498 96.7602 26.5498C96.9602 26.3498 97.2002 26.1898 97.4602 26.0798C97.7202 25.9698 98.0102 25.9198 98.2902 25.9198Z"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M12.1504 107.25V112.22"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M7.44022 116.93H2.47021"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M21.8801 116.93H16.8501"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M12.1504 126.66V121.63"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M16.8504 116.93C15.6004 116.93 14.4104 116.43 13.5204 115.55C12.6404 114.67 12.1404 113.47 12.1404 112.22C12.1404 112.84 12.0204 113.45 11.7904 114.03C11.5504 114.6 11.2104 115.12 10.7704 115.56C10.3304 116 9.81043 116.34 9.24043 116.58C8.67043 116.82 8.05043 116.93 7.44043 116.93C8.69043 116.93 9.88043 117.43 10.7604 118.31C11.6404 119.19 12.1404 120.39 12.1404 121.64C12.1404 121.02 12.2604 120.41 12.4904 119.83C12.7304 119.26 13.0704 118.74 13.5104 118.3C13.9504 117.86 14.4704 117.52 15.0404 117.28C15.6104 117.04 16.2304 116.93 16.8504 116.93Z"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M93.6201 227.01C93.6201 227.4 93.5101 227.77 93.2901 228.09C93.0801 228.41 92.7701 228.66 92.4201 228.81C92.0701 228.96 91.6801 228.99 91.3001 228.92C90.9201 228.85 90.5801 228.66 90.3101 228.39C90.0401 228.12 89.8501 227.77 89.7801 227.4C89.7101 227.02 89.7401 226.63 89.8901 226.28C90.0401 225.92 90.2901 225.62 90.6001 225.41C90.9201 225.2 91.2901 225.08 91.6801 225.08C91.9401 225.08 92.1901 225.13 92.4201 225.23C92.6601 225.33 92.8701 225.47 93.0501 225.65C93.2301 225.83 93.3701 226.05 93.4701 226.28C93.5701 226.52 93.6201 226.77 93.6101 227.02L93.6201 227.01Z"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M46.6402 187.67C46.2302 189.06 45.4702 190.32 44.4302 191.33C43.3902 192.34 42.1102 193.07 40.7102 193.45C39.3102 193.83 37.8402 193.83 36.4302 193.48C35.0302 193.12 33.7402 192.41 32.6902 191.41C31.6402 190.41 30.8702 189.16 30.4402 187.77C30.0102 186.38 29.9502 184.91 30.2602 183.5C30.5702 182.08 31.2302 180.77 32.1902 179.68C33.1502 178.59 34.3702 177.77 35.7402 177.3"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M91.0698 212.73C85.2198 209.61 87.4098 200.65 94.0798 200.65C95.2498 200.65 96.4098 200.98 97.4098 201.59C98.4098 202.2 99.2298 203.08 99.7698 204.12C100.31 205.16 100.55 206.33 100.47 207.51C100.39 208.68 99.9898 209.81 99.3198 210.77"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M93.6997 209.631V210.491"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M93.6997 203.65V204.51"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M92.4199 208.351C92.4199 208.601 92.4999 208.851 92.6399 209.061C92.7799 209.271 92.9799 209.441 93.2199 209.531C93.4599 209.621 93.7099 209.651 93.9599 209.601C94.2099 209.551 94.4399 209.431 94.6199 209.251C94.7999 209.071 94.9199 208.841 94.9699 208.591C95.0199 208.341 94.9899 208.081 94.8999 207.851C94.7999 207.621 94.6399 207.421 94.4299 207.271C94.2199 207.131 93.9699 207.051 93.7199 207.051C93.4699 207.051 93.2199 206.971 93.0099 206.831C92.7999 206.691 92.6299 206.491 92.5399 206.251C92.4399 206.021 92.4199 205.761 92.4699 205.511C92.5199 205.261 92.6399 205.031 92.8199 204.851C92.9999 204.671 93.2299 204.551 93.4799 204.501C93.7299 204.451 93.9899 204.481 94.2199 204.571C94.4499 204.671 94.6499 204.831 94.7999 205.041C94.9399 205.251 95.0199 205.501 95.0199 205.751"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M88.7998 218.01L95.1098 212.4C95.2398 212.28 95.4098 212.21 95.5898 212.21C95.7698 212.21 95.9398 212.26 96.0798 212.37L98.8498 214.58C98.9898 214.69 99.1698 214.75 99.3498 214.74C99.5298 214.74 99.6998 214.66 99.8398 214.54L105.02 209.7"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M102 209.71H105.02V212.73"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M46.8701 63.2397V44.6797"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M46.8701 46.0299C51.1001 49.0799 55.3301 42.9799 59.5501 46.0299V53.2799C55.3201 50.2299 51.0901 56.3299 46.8701 53.2799"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </G>
      <Defs>
        <ClipPath id="clip0_8667_162419">
          <Rect width={246.79} height={208.42} fill="white" transform="translate(2 21)" />
        </ClipPath>
      </Defs>
    </Svg>
  </Box>
)
